// extracted by mini-css-extract-plugin
export default {"header__cart-list-item--image":"header__cart-list-item--image_Ac_nekRC","header__cart-list-item--name":"header__cart-list-item--name_fvaVrlkE"};